// export utils here for validation

export default function ValidateUser(username, password) {
    // handle validation
    if (!username || !password) throw new Error('User credentials are required');

    return true;
}
